<ng-container *ngIf="_text"><small class="error">{{_text}}</small></ng-container>
